import ButtonPrimary from "./ButtonPrimary";
import { DARK } from "../core/constants";
import PropTypes from "prop-types";
import React from "react";
import { useCartContext } from "./CartContext";
import Box from "./Box";
import BodyText from "./BodyText";
import ButtonLoading from "./ButtonLoading";

function AddToCartButton({ variantId }) {
  const {
    cart: { id: cartId, lines },
    addToCart,
    addToCartLoading,
    cartError,
    setCartError,
  } = useCartContext();

  const lineItemIdsInBasket = lines.map((line) => {
    return line.node.merchandise.id;
  });
  const itemAlreadyInBasket = lineItemIdsInBasket.includes(variantId);

  let label = "Add to basket";
  if (itemAlreadyInBasket) {
    label = "Added to basket!";
  }
  if (addToCartLoading) {
    label = <ButtonLoading />;
  }

  return (
    <Box position="relative">
      <ButtonPrimary
        theme={DARK}
        fullWidth
        disabled={addToCartLoading || itemAlreadyInBasket}
        onClick={() => {
          if (cartError) {
            setCartError(false);
          }
          setCartError(false);
          addToCart({
            variables: {
              cartId,
              variantId: variantId,
            },
          });
        }}
      >
        {label}
      </ButtonPrimary>
      {cartError && (
        <Box position="absolute">
          <BodyText color="red">
            There was a problem adding this item to the cart
          </BodyText>
        </Box>
      )}
    </Box>
  );
}

export default AddToCartButton;

AddToCartButton.propTypes = {
  variantId: PropTypes.string.isRequired,
};
